(() => {
 'use strict';
 const dialog = document.getElementById('mobile-menu');
 const trigger = document.querySelector('.menu-toggle');
 if (!dialog || !trigger || typeof dialog.showModal !== 'function') return;
 const mobile = window.matchMedia('(max-width:650px)');
 const closeButton = dialog.querySelector('.ri-mobile-close');
 const initialHeading = dialog.querySelector('#mobile-menu-title');
 const scroller = dialog.querySelector('.ri-mobile-nav-scroll');
 const views = [...dialog.querySelectorAll('[data-mobile-view]')];
 const tabs = [...dialog.querySelectorAll('[data-mobile-tab]')];
 const panels = [...dialog.querySelectorAll('[data-mobile-panel]')];
 let pagePosition = null;
 let restoreFocus = true;

 function selectTab(name, focus = false) {
  tabs.forEach(tab => {
   const selected = tab.dataset.mobileTab === name;
   tab.setAttribute('aria-selected', String(selected));
   tab.tabIndex = selected ? 0 : -1;
   if (selected && focus) tab.focus({preventScroll:true});
  });
  panels.forEach(panel => { panel.hidden = panel.dataset.mobilePanel !== name; });
 }
 function selectView(name, focus = true) {
  dialog.dataset.mobileDirection = focus ? (name === 'catalog' ? 'forward' : 'back') : 'none';
  dialog.querySelector('[data-mobile-catalog]').setAttribute('aria-expanded',String(name === 'catalog'));
  views.forEach(view => { view.hidden = view.dataset.mobileView !== name; });
  scroller.scrollTop = 0;
  if (focus) {
   const target = name === 'catalog' ? dialog.querySelector('#mobile-catalog-title') : dialog.querySelector('#mobile-home-title');
   target.focus({preventScroll:true});
  }
 }
 function unlockPage() {
  if (!pagePosition) return;
  const saved = pagePosition;
  pagePosition = null;
  document.documentElement.classList.remove('ri-mobile-open');
  for (const [property, value] of Object.entries(saved.styles)) document.body.style[property] = value;
  const behavior = document.documentElement.style.scrollBehavior;
  document.documentElement.style.scrollBehavior = 'auto';
  window.scrollTo(saved.x, saved.y);
  document.documentElement.style.scrollBehavior = behavior;
 }
 function closeMenu(focus = true) {
  if (!dialog.open) return;
  restoreFocus = focus;
  dialog.close();
 }
 function openMenu() {
  if (dialog.open || !mobile.matches) return;
  selectView('home', false);
  selectTab('general');
  pagePosition = {x:window.scrollX,y:window.scrollY,styles:{}};
  for (const property of ['position','top','left','width','overflow']) pagePosition.styles[property] = document.body.style[property];
  document.documentElement.classList.add('ri-mobile-open');
  Object.assign(document.body.style,{position:'fixed',top:`-${pagePosition.y}px`,left:'0',width:'100%',overflow:'hidden'});
  dialog.showModal();
  restoreFocus = true;
  trigger.setAttribute('aria-expanded','true');
  initialHeading.focus({preventScroll:true});
 }
 trigger.addEventListener('click',openMenu);
 closeButton.addEventListener('click',() => closeMenu());
 dialog.addEventListener('close',() => {
  unlockPage();
  trigger.setAttribute('aria-expanded','false');
  if (restoreFocus && mobile.matches) trigger.focus({preventScroll:true});
 });
 dialog.addEventListener('cancel',() => { restoreFocus = true; });
 // Keep keyboard focus within the menu, including embedded browsing contexts.
 dialog.addEventListener('keydown',event => {
  if (event.key !== 'Tab') return;
  const focusable = [...dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]')].filter(element => element.getClientRects().length && element.tabIndex >= 0);
  const first = focusable[0], last = focusable[focusable.length - 1];
  if (event.shiftKey && (document.activeElement === first || document.activeElement === initialHeading)) { event.preventDefault(); last.focus(); }
  else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
 });
 dialog.querySelector('[data-mobile-catalog]').addEventListener('click',() => selectView('catalog'));
 dialog.querySelector('[data-mobile-back]').addEventListener('click',() => selectView('home'));
 tabs.forEach((tab,index) => {
  tab.addEventListener('click',() => selectTab(tab.dataset.mobileTab));
  tab.addEventListener('keydown',event => {
   let next;
   if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
   if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
   if (event.key === 'Home') next = 0;
   if (event.key === 'End') next = tabs.length - 1;
   if (next === undefined) return;
   event.preventDefault();
   selectTab(tabs[next].dataset.mobileTab,true);
  });
 });
 // Swipe-back gesture: Pointer Events cover touch, pen and mobile-width dragging.
 function attachSwipeBack(region, root, onBack) {
  let gesture = null;
  let pendingClick = false;
  const reset = () => {
   const previous = gesture;
   gesture = null;
   region.classList.remove('ri-mobile-swipe-tracking');
   if (previous && region.hasPointerCapture(previous.id)) region.releasePointerCapture(previous.id);
  };
  // A fresh press is intentional; only the click generated by a drag is suppressed.
  root.addEventListener('pointerdown',event => {
   pendingClick = false;
   if (gesture && event.pointerId !== gesture.id) reset();
  },true);
  region.addEventListener('pointerdown',event => {
   if (!root.open || region.hidden || !event.isPrimary || event.button !== 0) return;
   if (event.target.closest('input,textarea,select,[contenteditable="true"],[role="tablist"]')) return;
   reset();
   gesture = {id:event.pointerId,x:event.clientX,y:event.clientY,axis:null};
   region.classList.add('ri-mobile-swipe-tracking');
  });
  region.addEventListener('pointermove',event => {
   if (!gesture || event.pointerId !== gesture.id) return;
   const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
   if (!gesture.axis && Math.max(Math.abs(dx),Math.abs(dy)) >= 10) {
    gesture.axis = dx > 0 && dx > Math.abs(dy) * 1.35 ? 'right' : 'other';
    if (gesture.axis === 'right') region.setPointerCapture(event.pointerId);
   }
  });
  region.addEventListener('pointerup',event => {
   if (!gesture || event.pointerId !== gesture.id) return;
   const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
   const threshold = Math.min(90,Math.max(64,region.clientWidth * .2));
   const goBack = gesture.axis === 'right' && dx >= threshold && dx > Math.abs(dy) * 1.5;
   pendingClick = Math.max(Math.abs(dx),Math.abs(dy)) >= 12;
   reset();
   if (goBack) onBack();
  });
  root.addEventListener('click',event => {
   if (!pendingClick || event.detail === 0) return;
   pendingClick = false;
   event.preventDefault();
   event.stopPropagation();
  },true);
  // Native vertical pan/pinch can cancel a pointer; never turn that into a back action.
  region.addEventListener('pointercancel',reset);
  region.addEventListener('lostpointercapture',reset);
  region.addEventListener('contextmenu',reset);
  region.addEventListener('dragstart',event => { if (gesture) event.preventDefault(); });
  root.addEventListener('close',() => { reset(); pendingClick = false; });
 }

 // End swipe-back gesture.
 attachSwipeBack(dialog.querySelector('[data-mobile-view="catalog"]'),dialog,() => selectView('home'));
 dialog.addEventListener('click',event => { if (event.target.closest('a[href]')) closeMenu(false); });
 mobile.addEventListener('change',() => { if (!mobile.matches) closeMenu(false); });
 window.addEventListener('pagehide',() => { closeMenu(false); unlockPage(); });
 window.addEventListener('pageshow',() => { if (!dialog.open) trigger.setAttribute('aria-expanded','false'); });
})();
